/**
 * WARNING: We can unfortunately not extend this enum
 * without breaking old versions of the app and web portal.
 * Applying any other value than "HCP" on a tenant with <V8 client
 * will throw error.
 */
export enum RequestInitiatorTypeV1 {
  HCP = 'HCP',
}
